import { type IShellNavItem } from "@btnet/core-components/BTShellLayout";

/**
 * Dummy sidebar nav data for the research-preview shell (ado-285671): 20 placeholder items
 * standing in for a real nav API response. Fixture data, so it lives here in Clients.App
 * rather than the component library: `ResearchPreviewLayout` (the app's research-preview
 * shell) and `BTShellLayout.stories.tsx`'s `WithNav` (the generic nav-shell demo) share it.
 * Each caller owns its own selection state — a `useState` seeded with the first item's key.
 */
export const RESEARCH_PREVIEW_SHELL_NAV_ITEMS: IShellNavItem[] = Array.from(
    { length: 20 },
    (_, i) => ({
        key: `item${i}`,
        label: `Item ${i + 1}`,
    }),
);
